interface ILanguageData {
  key: string;
  value: string;
}
export const languageData: ILanguageData[] = [
  { key: 'en', value: 'English' },
  { key: 'es', value: 'Spanish' },
  { key: 'fr', value: 'French' },
  { key: 'de', value: 'German' },
  { key: 'pt', value: 'Portuguese' },
  { key: 'vi', value: 'Vietnamese' },
  { key: 'fil', value: 'Tagalog' },
  { key: 'zh-CN', value: 'Chinese (Simplified)' },
  { key: 'zh-TW', value: 'Chinese (Traditional)' },
];

export const KP_CORPORATION_CLIENT_ID = 53090;

const KP_COURSE_VIEW_LANGUAGE_KEYS = ['en', 'es', 'vi', 'fil'];

export const getCourseViewLanguages = (clientId?: number): ILanguageData[] => {
  if (clientId === KP_CORPORATION_CLIENT_ID) {
    return languageData.filter(({ key }) =>
      KP_COURSE_VIEW_LANGUAGE_KEYS.includes(key)
    );
  }

  return languageData;
};
